const lang = {
  // phan quyen
  // 'admin.customer.list': 'Xem danh sách khách hàng',
  // 'admin.customer.create': 'Thêm mới khách hàng',
  // 'admin.customer.detail': 'Xem chi tiết khách hàng',
  // 'admin.customer.update': 'Cập nhật thông tin khách hàng',
  // 'admin.customer.remove': 'Xoá khách hàng',
  // 'admin.customer.export': 'Download thông tin khách hàng',

  // 'admin.potential_customer.list': 'Xem danh sách khách hàng tiềm năng',
  // 'admin.potential_customer.create': 'Thêm mới khách hàng tiềm năng',
  // 'admin.potential_customer.detail': 'Xem chi tiết khách hàng tiềm năng',
  // 'admin.potential_customer.update': 'Cập nhật thông tin khách hàng tiềm năng',
  // 'admin.potential_customer.remove': 'Xoá khách hàng tiềm năng',

  // 'admin.customer_history.list': 'Xem lịch sử làm việc khách hàng',
  // 'admin.customer_history.create': 'Thêm mới lịch sử làm việc khách hàng',
  // 'admin.customer_history.remove': 'Xoá lịch sử làm việc khách hàng',

  // 'admin.datacenter_request.list': 'Xem danh sách yêu cầu Datacenter',
  // 'admin.datacenter_request.create': 'Thêm mới yêu cầu Datacenter',
  // 'admin.datacenter_request.detail': 'Xem chi tiết yêu cầu Datacenter',
  // 'admin.datacenter_request.remove': 'Xoá yêu cầu Datacenter',
  // 'admin.datacenter_request.export': 'Download danh sách yêu cầu Datacenter',

  // 'admin.documentation.list': 'Xem danh sách tài liệu',
  // 'admin.documentation.create': 'Thêm mới tài liệu',
  // 'admin.documentation.detail': 'Xem chi tiết tài liệu',
  // 'admin.documentation.update': 'Cập nhật thông tin tài liệu',
  // 'admin.documentation.remove': 'Xoá tài liệu',

  // 'admin.notification.list': 'Xem danh sách thông báo',
  // 'admin.notification.create': 'Thêm mới thông báo',
  // 'admin.notification.detail': 'Xem chi tiết thông báo',
  // 'admin.notification.update': 'Cập nhật thông báo',
  // 'admin.notification.remove': 'Xoá thông báo',

  // 'admin.partner.list': 'Xem danh sách đối tác',
  // 'admin.partner.create': 'Thêm mới đối tác',
  // 'admin.partner.detail': 'Xem chi tiết đối tác',
  // 'admin.partner.update': 'Cập nhật thông tin đối tác',
  // 'admin.partner.remove': 'Xoá đối tác',

  // 'admin.product.list': 'Xem danh sách dịch vụ',
  // 'admin.product.create': 'Thêm mới dịch vụ',
  // 'admin.product.detail': 'Xem chi tiết dịch vụ',
  // 'admin.product.update': 'Cập nhật thông tin dịch vụ',
  // 'admin.product.remove': 'Xoá dịch vụ',
  // 'admin.product.send_postage': 'Gửi thông báo cước dịch vụ',
  // 'admin.product.send_overload_alert': 'Gửi thông báo quá tải',
  // 'admin.product.export': 'Download danh sách dịch vụ',

  // 'admin.product_category.list': 'Xem danh sách danh mục dịch vụ',
  // 'admin.product_category.create': 'Thêm mới danh mục dịch vụ',
  // 'admin.product_category.detail': 'Xem chi tiết danh mục dịch vụ',
  // 'admin.product_category.update': 'Cập nhật thông tin danh mục dịch vụ',
  // 'admin.product_category.remove': 'Xoá danh mục dịch vụ',

  // 'admin.service.list': 'Xem danh sách sản phẩm',
  // 'admin.service.create': 'Thêm mới sản phẩm',
  // 'admin.service.detail': 'Xem chi tiết sản phẩm',
  // 'admin.service.update': 'Cập nhật thông tin sản phẩm',
  // 'admin.service.remove': 'Xoá sản phẩm',

  // 'admin.support_request.list': 'Xem danh sách yêu cầu hỗ trợ',
  // 'admin.support_request.create': 'Tạo yêu cầu hỗ trợ',
  // 'admin.support_request.detail': 'Xem chi tiết yêu cầu hỗ trợ',
  // 'admin.support_request.update': 'Cập nhật yêu cầu hỗ trợ',
  // 'admin.support_request.response': 'Phản hồi hỗ trợ',

  // 'admin.user.list': 'Xem danh sách user',
  // 'admin.user.create': 'Thêm mới user',
  // 'admin.user.detail': 'Xem chi tiết user',
  // 'admin.user.update': 'Cập nhật thông tin user',
  // 'admin.user.remove': 'Xoá user',

  // 'admin.permissions.list': 'Xem danh sách quyền',
  // 'admin.permissions.update': 'Phân quyền',
  // 'admin.permissions.get_by_role': 'Lấy danh sách quyền theo vai trò',

  // 'admin.task.list': 'Xem danh sách công việc hằng ngày',
  // 'admin.task.create': 'Thêm mới công việc hằng ngày',
  // 'admin.task.detail': 'Xem chi tiết công việc hằng ngày',
  // 'admin.task.update': 'Cập nhật thông tin công việc hằng ngày',
  // 'admin.task.remove': 'Xoá công việc hằng ngày',

  // 'admin.role.list': 'Xem danh sách vai trò',
  // 'admin.role.create': 'Thêm mới vai trò',
  // 'admin.role.detail': 'Xem chi tiết vai trò',
  // 'admin.role.update': 'Cập nhật thông tin vai trò',
  // 'admin.role.remove': 'Xoá vai trò',

  // 'admin.business.get_revenue_in_month': 'Xem báo cáo doanh thu trong tháng',
  // 'admin.business.get_report': 'Xem báo cáo của nhân viên',
  // 'admin.business.list_transaction': 'Xem lịch sử giao dịch',
  // 'admin.business.create_transaction': 'Tạo mới giao dịch',
  // 'admin.business.detail_transaction': 'Xem chi tiết giao dịch',
  // 'admin.business.update_transaction': 'Cập nhật giao dịch',
  // 'admin.business.remove_transaction': 'Xoá giao dịch',
  // 'admin.potential_customer.import': 'Import từ Excel',

  // 'admin.warehouse.list': 'Xem danh sách thiết bị trong kho',
  // 'admin.warehouse.create': 'Thêm mới thiết bị vào kho',
  // 'admin.warehouse.detail': 'Xem chi tiết thiết bị',
  // 'admin.warehouse.update': 'Cập nhật thông tin thiết bị',
  // 'admin.warehouse.remove': 'Xoá thiết bị',

  // 'admin.order.list': 'Xem danh sách yêu cầu mua hàng',
  // 'admin.order.detail': 'Xem chi tiết yêu cầu mua hàng',
  // 'admin.order.update': 'Cập nhật yêu cầu mua hàng',

  // 'admin.shop.list': 'Xem danh sách gian hàng đối tác',
  // 'admin.shop.create': 'Thêm mới gian hàng đối tác',
  // 'admin.shop.detail': 'Xem chi tiết gian hàng đối tác',
  // 'admin.shop.update': 'Cập nhật thông tin gian hàng đối tác',
  // 'admin.shop.remove': 'Xoá gian hàng đối tác',

  // 'admin.service_category.list': 'Xem danh sách danh mục sản phẩm',
  // 'admin.service_category.create': 'Thêm mới danh mục sản phẩm',
  // 'admin.service_category.detail': 'Xem chi tiết danh mục sản phẩm',
  // 'admin.service_category.update': 'Cập nhật thông tin danh mục sản phẩm',
  // 'admin.service_category.remove': 'Xoá danh mục sản phẩm',

  // 'admin.mail.send': 'Gửi mail tới khách hàng',
  // 'admin.mail.send_many': 'Gửi thông báo chăm sóc (tới nhiều khách hàng)',
  // 'admin.mail.get_template': 'Xem mẫu email',
  // 'admin.mail.set_template': 'Cập nhật mẫu email',

  // 'admin.web_customer.list': 'Xem danh sách khách hàng từ web',
  // 'admin.web_customer.detail': 'Xem chi tiết khách hàng từ web',
  // 'admin.web_customer.update': 'Cập nhật khách hàng từ web',
  // 'admin.web_customer.remove': 'Xoá khách hàng từ web',

  // 'admin.export.customer': 'Download dữ liệu khách hàng',
  // 'admin.export.product':
  //   'Download dữ liệu dịch vụ (bao gồm đang chạy, cắt huỷ, tạm dừng)',
  // 'admin.export.datacenter_request': 'Download yêu cầu datacenter',
  // 'admin.export.support_request': 'Download yêu cầu hỗ trợ từ khách hàng',
  // 'admin.export.customer_history': 'Download lịch sử làm việc với khách hàng',
  // 'admin.export.product_history': 'Download lịch sử thay đổi dịch vụ',
  // 'admin.export.product_overload': 'Download thông báo dịch vụ quá tải',
  // 'admin.product_overload.list': 'Xem danh sách thông báo quá tải',

  // 'admin.customer_support_calls.list': 'Xem danh sách khách hàng cần chăm sóc',
  // 'admin.customer_support_calls.create': 'Tạo ghi chú sau khi chăm sóc',

  // card title
  // 'admin.customer': 'Khách hàng',
  // 'admin.customer_history': 'Lịch sử làm việc khách hàng',
  // 'admin.datacenter_request': 'Yêu cầu datacenter',
  // 'admin.documentation': 'Tài liệu',
  // 'admin.notification': 'Thông báo khuyến mãi',
  // 'admin.partner': 'Đối tác datacenter',
  // 'admin.permissions': 'Phân quyền',
  // 'admin.potential_customer': 'Khách hàng tiềm năng',
  // 'admin.product': 'Dịch vụ',
  // 'admin.product_category': 'Danh mục dịch vụ',
  // 'admin.role': 'Quản lý vai trò',
  // 'admin.service': 'Sản phẩm đối tác',
  // 'admin.support_request': 'Yêu cầu hỗ trợ',
  // 'admin.task': 'Công việc hằng ngày',
  // 'admin.user': 'User',
  // 'admin.warehouse': 'Kho thiết bị',
  // 'admin.business': 'Báo cáo kinh doanh',
  // 'admin.shop': 'Gian hàng đối tác',
  // 'admin.order': 'Yêu cầu mua hàng',
  // 'admin.service_category': 'Danh mục sản phẩm đối tác',
  // 'admin.mail': 'Mail',
  // 'admin.web_customer': 'Khách hàng từ web',
  // 'admin.export': 'Download dữ liệu',
  // 'admin.product_overload': 'Thông báo quá tải',
  // 'admin.customer_support_calls': 'Chăm sóc khách hàng',
  // 'global.avatar': 'Ảnh',
  // 'global.full_name': 'Họ tên',
  // 'global.created': 'Ngày đăng kí',
  'global.role': 'Role',
  'global.add': 'Add New',
  'global.route_markets': 'Route Markets',
  // 'global.edit': 'Sửa',
  'global.password': 'Password',
  'global.resetpassword': 'Reset password',
  'global.input_password': 'Input password',
  'global.is_verified_email': 'Verify email',
  'global.collaborator': 'Collaborator',
  'global.is_mobile_verified': 'Verify phone',
  'global.operator_user': 'Operator user',
  'global.unverified': 'Unverified',
  'global.store': 'Store',
  'global.verified': 'Verified',
  // 'global.admin': 'Quản trị viên',
  // 'global.staff': 'Nhân viên',
  // 'global.gender': 'Giới tính',
  // 'global.date_of_bird': 'Date of birth',
  // 'global.identity': 'CMT/CCCD',
  // 'global.bhyt': 'BHYT',
  // 'global.nam': 'Nam',
  // 'global.nu': 'Nữ',
  // 'global.ngay_cap': 'Ngày cấp',
  // 'global.noi_cap': 'Nơi cấp',
  // 'global.so_bhyt': 'Số BHYT',
  // 'widgets.recentNotifications': 'Thông báo gần đây',
  // 'button.viewAll': 'Xem tất cả',
  // 'widgets.recentMessage': 'Tin nhắn gần đây',
  // 'global.user': 'Người dùng',
  // 'global.status': 'Trạng thái',
  'global.status': 'Status',
  'global.add_price': 'Add price',
  'global.add_new': 'Add new',
  'global.published': 'Published',
  'global.unpublished': 'Unpublished',
  'global.delete': 'Delete',
  'global.copy': 'Copy',
  'global.create': 'Create',
  'global.update': 'Update',
  'global.image': 'Image',
  'global.image_alt': 'Alternative image',
  'global.schema_type': 'Schema type',
  'global.title': 'Title',
  'global.slug': 'Slug',
  'global.sub_title': 'Sub title',
  'global.company': 'Company',
  'global.id': 'ID',
  'global.tabbasic': 'Basic',
  'global.alias': 'Alias',
  'global.description': 'Description',
  'global.cancel': 'Cancel',
  'global.active': 'Active',
  'global.deactivate': 'Deactivate',
  'global.submit': 'Submit',
  'global.edit': 'Edit',
  'global.trashed': 'Trashed',
  'global.approved': 'Approved',
  'global.approve': 'Approve',
  'global.from': 'From',
  'global.to': 'To',
  'global.price_discount': 'Price discount',
  'global.price_roundtrip': 'Price roundtrip',
  'global.price': 'Price',
  'global.infant_price': 'Infant price',
  'global.car': 'Car',
  'global.type': 'Type',
  'global.rating': 'Rating',
  'global.room_rate': 'Room rate',
  'global.cancel_policy': 'Cancel policy',
  'global.instant_bookable': 'Instant bookable',
  'global.yes': 'Yes',
  'global.no': 'No',
  'global.city': 'City',
  'global.street': 'Street',
  'global.neighbourhood_cleansed': ' Cleansed',
  'global.neighbourhood_group_cleansed': ' Group cleansed',
  'global.location': 'Location',
  'global.choose-location': 'Choose location',
  'global.square_feet': 'Square Feet',
  'global.bedrooms': 'Bedrooms',
  'global.bathrooms': 'Bathrooms',
  'global.beds': 'Beds',
  'global.bed_type': 'Bed_type',
  'global.cover_img': 'Cover image',
  'global.gallery': 'Gallery',
  'global.gallerySetting': 'Gallery Setting',
  'global.security_deposit': 'Security deposit ',
  'global.guests_included': 'Guests included',
  'global.minimum_nights': 'Minimum nights',
  'global.cleaning_fee': 'Cleaning fee',
  'global.extra_people': 'Extra people',
  'global.maximum_nights': 'Maximum nights',
  'global.months': 'Months',
  'global.calendar': 'Calendar',
  'global.province': 'Province',
  'global.district': 'District',
  'global.ward': 'Ward',
  'global.no_house': 'House number',
  'global.nearbyUtils': 'Near by utils',
  'global.extra_price': 'Extra price',
  'global.patients': 'Patients',
  'global.setting': 'Setting',
  'global.appointments': 'Appointments',
  'global.suppliers': 'Suppliers',
  'global.id_number': 'ID',
  'global.code': 'Code',
  'global.name': 'Name',
  'global.services': 'Services',
  'global.clinic': 'Clinic',
  'global.website': 'Website',
  'global.contact_name': 'Contact',
  'global.refresh': 'Refresh',
  'global.distance': 'Distance',
  'global.update_success': 'Updated success!',

  'car.driver': 'Driver',
  'car.seat': 'Seat',
  'car.luggage': 'Luggage',
  'car.ordering': 'Booking',
  'car.facility': 'Facility',
  'car.air_machine': 'Air machine',
  'car.energy_saving': 'Energy saving',
  'car.stop_point': 'Stop point',
  'property.start_date': 'Start date ',
  'property.end_date': 'End date',
  'property.price_week': 'Price week',
  'property.weekend_price': 'Price weekend',
  'property.extra_price': 'Extra price',
  'property.host_languages': ' Host languages',
  'property.week_term_promo': 'Week term promo',
  'property.month_term_promo': 'Month term promo',
  'property.price_weekend': 'Price weekend',
  'global.guests_standard': 'Guests standard',
  'global.guests_max': 'Guests max',
  'sidebar.transport': 'Transport',
  'sidebar.amenity': 'Amenity',
  'sidebar.restaurant': 'Restaurant',
  'sidebar.property': 'Property',
  'sidebar.property_type': 'Property type',
  'sidebar.room': 'Room',
  'sidebar.cancel_policy': 'Cancel policy',
  'sidebar.vehicle': 'Vehicle',
  'sidebar.car': 'Car',
  'sidebar.route': 'Route',
  'sidebar.routes': 'Routes',
  'sidebar.inbox': 'Inbox',
  'sidebar.conversation': 'Conversation',
  'sidebar.reservations': 'Reservations',
  'sidebar.earning': 'Earning',
  'sidebar.calendar': 'Calendar',
  'sidebar.reports': 'Reports',
  'sidebar.services': 'Services',
  'sidebar.addons_order': 'Additional services',
  'sidebar.debt_confirmation_record': 'Debt confirmation record',
  'global.requiredfield': 'Required field',
  'global.numberfield': 'Field must be number',

  'property.room_type': 'Room type',
  'global.propertytypes': 'Property type',
  'global.save': 'Save',
  'global.save_and_close': 'Save & close',
  'global.signin': 'Sign in',
  'global.signup': 'Signup',
  'global.forgot_password': 'Forgot password',
  'global.search_placeholder': 'Rechercher',

  'global.sms_settings': 'SMS Settings',
  'global.app_settings': 'App Settings',

  'global.disabled': 'Disabled',
  'global.enabled': 'Enabled',

  //sms settings
  'global.sender_id': 'SenderID',
  'global.user_app': 'User App',
  'global.operator_app': 'Operator App',

  //user app settings
  'global.app_listing': 'App listing',
  'global.app_status': 'App status',
  'global.booking_message': 'Booking message',
  'global.booking': 'Booking',
  'global.selling_start': 'Selling start',
  'global.any_time': 'Anytime',
  'global.custom': 'Custom',

  //Tour
  'global.duration': 'Duration',
  'global.routes': 'Routes',
  'global.category': 'Category',
  'global.cover_image': 'Cover',
  'global.url': 'Image url',
  'global.operator': 'Operator',
  'global.from_price': 'Prices',
  'global.itinerary': 'Itinerary',
  'global.itineraries': 'Itineraries',
  'global.updated_at': 'Updated at',
  'global.from_priceMGMT': 'Prices',
  'global.from_price_setting': ' Prices setting',
  'global.tours': 'Tours',
  'global.transportation': 'Transportation',
  'global.score': 'Score',
  'global.tour_option': 'Tour options',
  'global.hourly': 'Hourly',
  'tour.title': 'Title',
  'global.select_category': 'Select category',
  'global.select_operator': 'Select operator',
  'global.select_cabin_type': 'Select cabin type',
  'tour.description': 'Tour description',
  'tour.inclusion': 'Inclusion',
  'tour.exclusion': 'Exclusion',
  'global.inactive': 'Inactive',
  'global.meal': 'Meals',
  'global.category_operator': 'Category and operator',
  'tour.pricing': 'Pricing model',
  'tour.special': 'Special',
  'tour.normal': 'Normal',
  'tour.featured': 'Featured',
  'tour.time_mgmt': 'Time management',
  'tour.duration_unit': 'Duration unit',
  'tour.duration': 'Duration',
  'tour.start_time': 'Start time',
  'tour.instant_confirm': 'Instant confirm',
  'global.delete_confirm': 'Are you sure want to delete this item?',
  'global.cancel_order': 'Are you sure want to cancel this item?',
  'tour.gallery': 'Gallery',
  'global.ticket': 'Ticket',
  'global.display': 'Display',
  'global.min_person': 'Min person',
  'global.freeCancelHours': 'Free cancel hours',
  'global.freeCancel': 'Free cancel',
  'tour.freeCancel': 'Free cancel',
  'global.cancelPolicy': 'Cancel policy',
  'global.meeting': 'Meeting point',
  'global.meetingPoint': 'Meeting point',
  'global.meeting_point': 'Meeting point',
  'global.meeting_point_type': 'Meeting point type',
  'global.meetingPointNotes': 'Meeting point notes',
  'tour.cutOffTime': 'Cut off time(hours)',
  'tooltip.cutOffTime': 'e.g: 2 days before departure date is 48 hours',
  'global.perPerson': 'Per person',
  'global.perGroup': 'Per group',
  'global.optionTitle': 'Option title',
  'global.checkall': 'Check all',

  'global.show_seat_map': 'Show Seat Map',

  //trajet
  'global.trajet': 'Trajet',
  'global.lieu_arrivee': 'Lieu Arrivee',
  'global.heure_ramassage': 'Heure Ramassage',
  'global.heure': 'Heure',
  'global.lieu_depart': 'Lieu Depart',
  'global.depart': 'Depart',
  'global.arrivee': 'Arrivee',
  'global.prix': 'Prix',
  'global.sous_trajet_id': 'Sous Trajet Id',
  'global.code_trajet': 'Code Trajet',
  'global.policy': 'Policy',
  'global.app_id': 'App Id',

  'global.collaborators': 'Collaborators',

  //Seatmap
  'global.chosen': 'Chosen',
  'global.taken': 'Taken',
  'global.locked': 'Locked',
  'global.free': 'Free',

  //Option
  'global.max_person': 'Max person',
  'global.max': 'Max',
  'global.adult_price': 'Adult price',
  'global.child_price': 'Child price',
  'global.cost_price': 'Cost price',
  'global.cost': 'Cost',
  'global.selling_price': 'Selling price',
  'global.selling': 'Selling',
  'global.cost_price_notes': 'Cost price notes',
  'global.select_tour': 'Select tour',
  'global.option': 'Option',
  'global.options': 'Options',
  'option.group': 'Group',
  'global.Vehicle_type': 'Vehicle type',
  'global.timeStart': 'Time start',
  'global.startWorkingTime': 'Start working time',
  '.endWorkingTime': 'End working time',

  //Destination
  'global.destination': 'Destination',
  'global.select_destination': 'Select destination',
  'global.countries': 'Country',
  'global.select_country': 'Select country',
  'destination.longitude': 'Longitude',
  'destination.latitude': 'Latitude',
  'global.destination_parent': 'Destination parent',

  //Categories
  'global.categories': 'Categories',

  //Operators
  'global.operators': 'Operators',
  'global.firstname': 'First name',
  'global.lastname': 'Last name',
  'global.email': 'Email',
  'global.phone': 'Phone',
  'global.hotline': 'Hotline',
  'global.params': 'Params',
  'global.limit_order_start_time': 'Limit order start time',
  'global.allow_change_order_after_departure_hour':
    'Allow change order after departure hour',
  'global.allow_change_order_after_departure':
    'Allow change order after departure',
  'global.allow_change_order_before_departure':
    'Allow change order before departure',
  'global.tax_rate': 'Tax rate',

  //Currencies
  'global.currencies': 'Currency',
  'currency.name': 'Name',
  'currency.display': 'Display',
  'currency.exchange_rate': 'Exchange rate',
  'currency.thousand': 'Format',
  'currency.image': 'Icon',
  'currency.symbol': 'Symbol',
  //post
  'global.posts': 'Posts',
  'post.fulltext': 'Full Text',
  'post.short': 'Short',
  'global.featured': 'Featured',
  'post.hit': 'Hit',
  'post.metadesc': 'Meta desc',
  'post.metakey': 'Meta key',
  'post.image': 'Image',

  //home
  'global.total_booking_today': 'Bookings',
  'global.total_segments': 'Segments',
  'global.total_revenue_today': 'Revenues',
  'global.total_seat_today': 'Seats',
  //Log-in Log-out
  'global.account_information': 'Account information',
  'global.signout': 'Sign out',
  'global.email_required': 'Email required',
  'global.password_required': 'Password required',
  'global.email_not_valid': 'Email not valid',

  //Site:
  'global.site': 'Site',
  'sites.hotline': 'Hotline',
  'sites.locale': 'Locale',
  'sites.from_email': 'From email',
  'sites.from_name': 'From name',
  'sites.currency': 'Currency',
  'sites.timezone': 'Time zone',
  'sites.meta_description': 'Meta description',
  'sites.meta_title': 'Meta title',
  'sites.email': 'Email',
  'global.sites': 'Sites',
  //Bookings:
  'global.order': 'Booking',
  'global.orderId': 'Booking ID',
  'global.sell_by': 'Sell by',
  'order.tour_title': 'Tour title',
  'order.route_title': 'Title',
  'order.pay_status': 'Pay status',
  'order.order_status': 'Booking status',
  'order.voucher_status': 'Voucher status',
  'order.vat_status': 'VAT status',
  'order.depart_date': 'Depart date',
  'order.customer': 'Customer',
  'order.totalTravelers': 'Total traveler',
  'order.totalPrice': 'Total price',
  'order.created': 'Booked at',
  'order.created_by': 'Created by',
  'order.create': 'Create booking',
  'order.order_seat': 'Seat Allocation',
  'global.one_way': 'One way',
  'global.two_way': 'Two way',
  'global.time': 'Time',
  'global.search': 'Rechercher',
  'global.departure': 'Departure',
  'global.return': 'Return',
  'global.assign_operator': 'Assign operator',
  'global.assign': 'Assign',
  'global.total': 'Total',
  'global.group_code': 'Code',
  'global.update_status': 'Update status',
  'order.depart/return': 'Depart / Return',
  //Customers:
  'global.customers': 'Customers',
  'global.fullname': 'Full name',
  'global.userId': 'User ID',
  'global.company_name': 'Company name',
  'global.company_shortname': 'Short name',
  'global.company_tax_id': 'Tax code',
  'global.address': 'Address',
  'customer.create': 'Create',

  //Orders
  'orders.start_date': 'Start date',
  'orders.total': 'Total',
  'orders.order_status': 'Order status',
  'orders.created': 'Created',

  //Users:
  'global.roles': 'Role',
  'global.users': 'Users',

  //Schedule
  'global.schedule_setting': 'Schedule setting',
  'global.schedule': 'Schedule',
  'global.start_date': 'Start date',
  'global.end_date': 'End date',
  'global.weekdays': 'Week days',

  'global.weekday': 'Weekday',
  'global.statistic': 'Statistic',
  'global.view_seat_map': 'View seat map',
  'global.booked_seat': 'Booked seat',
  'global.disabled_seats': 'Disabled seat',
  'global.preview_seat_map': 'Preview seat map',

  'global.disabled_seat': 'Disable seat',
  'global.enable_seat': 'Enable seat',
  //wishlist
  'global.wishlist': 'Wishlist',
  'wishlist.tour_title': 'Tour title',
  'wishlist.customer': 'Customer',
  'global.basic': 'Basic',
  'global.item': 'Item',
  'global.items': 'Items',
  'global.sku': 'SKU',
  'global.widgets': 'Widgets',
  'global.widget': 'Widget',

  //menus
  'global.menus': 'Menus',
  'global.menu': 'Menu',
  'global.key': 'Key',
  'global.menu_items': 'Menu items',
  'global.menu_item': 'Menu item',

  //Register
  'global.registration_header': 'Register form',
  'global.country': 'Country',
  'global.mobile': 'Mobile',
  'signup.back_to_login': 'Back to login',
  'global.continue': 'Continue',
  'global.close': 'Close',

  //
  'global.statistics': 'Statistics',
  'global.tour_rates': 'Rates',
  'global.tour_options': 'Options',
  'global.destinations': 'Destinations',
  'global.orders': 'Orders',
  'global.reviews': 'Reviews',

  'global.language': 'Language',
  'global.currency': 'Currency',
  'global.your_plan': 'Plan',
  'global.trial_end': 'Expired date',
  'global.timezone': 'Timezone',
  'global.emai_required': 'Yêu cầu điền email',
  // 'global.password_required': 'Yêu cầu điền mật khẩu',
  'global.emai_not_valid': 'Email không đúng định dạng',
  'global.confirm_password': 'Confirm password',
  'global.changepassword': 'Change password',
  'global.confirm_new_password': 'Confirm new password',
  'global.new_password': 'New password',
  'global.current_password': 'Current password',
  'global.password_not_match': 'Password not match',
  'global.password_min_charactor': '6 characters min',
  'global.home': 'Home',

  'global.please_select_start_and_stop_destination':
    'Please select start & stop destination',

  // Cabins
  'global.cabins': 'Cabins',
  'global.size': 'Size',
  'global.qty': 'Quantity',
  'global.route': 'Route',

  // Customer Groups
  'global.discount': 'Discount',
  'global.cGroups': 'Customer groups',
  'global.group': 'Group',

  //
  'global.hops': 'Hops',
  'global.systems': 'Systems',
  'global.start_time': 'Start time',
  'global.start_stop': 'Destination start',
  'global.end_stop': 'Destination end',
  'global.cabin-rates': 'Cabin rates',
  'global.title_route': 'Route',

  // Addons
  'global.addons': 'Additional services',
  'global.seat': 'Seat',
  'global.from_date': 'From',
  'global.to_date': 'To date',

  'global.order_group': 'Booking group',
  'global.route_tital': 'Route',
  'global.select_customer': 'Select customer',
  'global.select_option': 'Select option',
  'global.order_status': 'Booking status',
  'global.pay_method': 'Payment method',
  'global.order_cancel': 'Are you sure want to cancel this order?',
  'order.pax': 'Pax',
  'global.passport': 'Passport',
  'global.addnew': 'Add',
  'global.select_county': 'Select county',
  'global.cabin': 'Cabin',
  'global.price_type': 'Price type',
  'global.voucher': 'Voucher',
  'global.passengers': 'Passengers',
  'global.notes': 'Notes',
  'global.order_id': 'Booking ID',
  'global.select_date': 'Select date',
  'global.select_hops': 'Select hop',
  'global.pay_status': 'Pay status',
  'bill.serial': 'Serial',
  'bill.billed_date': 'Payment date',
  'bill.amount': 'Amount',
  'global.method': 'Method',
  'global.wave_template_sms': 'Wave Template SMS',
  'global.suffix_userapp': 'Suffix user app',
  'global.suffix_operatorapp': 'Suffix operator app',
  'global.is_on_operatorapp': 'Operator app',
  'global.is_on_userapp': 'User app',
  'global.fee': 'Fee',
  'global.fee_default': 'Fee default',
  'global.field': 'Field',
  'global.payment_method': 'Payment method',
  'global.op_payment_method': 'Operator Payment method',
  'global.seat_lock': 'Seat lock',
  'global.session': 'Session',
  'global.bills': 'Payment ',
  'global.notpaid': 'Not paid',
  'global.paid': 'Paid',
  'global.collect': 'Collect',
  'global.spend': 'Spend',
  'global.cash': 'Cash',
  'global.card': 'Card',
  'global.bank': 'Bank',
  'global.insurance': 'Insurance',
  'global.select_customers': 'Select customer',
  'global.select_types': 'Select type',
  'sidebar.dept': 'AR',
  'global.total_debt_begin_period': 'Debt begin period',
  'global.total_paid_begin_period': 'Paid begin period',
  'global.total_debt_in_period': 'Debt in period',
  'global.total_paid_in_period': 'Paid in period',
  'global.total_debt_end_period': 'Total debt',

  'global.ar': 'Account receivable',
  'global.confirm': 'Confirm',
  'global.order_confirm': 'Are you sure want to confirm this order?',
  'global.bill_confirm': 'Are you sure want to approve this bill?',
  // 'global.cabin_rates': 'Cabin rates',
  'global.bookingCalendar': 'Booking calendar',
  'global.invoice': 'Invoice',
  'global.list_order_not_paid': 'List order not paid',
  'global.export_to_excel': 'Export to Excel',
  'global.report_debt_confirmation': 'Debt confirmation record',
  'global.debt': 'AR records',
  'global.bill': 'Payment',
  'global.record': 'Record',
  // report
  'global.date': 'Date',
  'global.hop': 'Hop',
  'global.addon': 'Add-on',
  'global.customer': 'Customer',
  'global.year': 'Year',

  'global.select_menu': 'Select menu',
  'global.select_role': 'Select role',

  'global.add_walk_in_customer': 'Add walk-in customer',
  'global.order_details': 'Booking details',
  'global.cabins_order': 'Cabins order',
  'global.last_30_day': 'Last 30 days',
  'global.last_7_day': 'Last 7 days',
  'global.last_month': 'Last month',
  'global.this_month': 'This month',
  'global.next_month': 'Next month',
  'global.seller': 'Seller',
  'global.send_email': 'Send email',
  'global.sale': 'Sale',
  'global.finance': 'Finance',
  'global.carriages': 'Carriages',
  'global.logo': 'Logo',
  'global.content': 'Content',
  'global.path': 'Path',
  'global.seat_allocation': 'Seat allocation',
  'global.cabinSerials': 'Cabin serials',
  'global.title_carriage': 'Title carriage',
  'global.title_cabin': 'Title cabin',
  'global.select_carriage': 'Select carriage',
  'global.order_seat': 'Booking seat',
  'global.order_seats': 'Booking seats',
  'global.Seat': 'Seat',
  'global.lock': 'Lock',
  'global.expiration': 'Expiration',
  'global.depart_seating': 'Depart seating',
  'global.return_seating': 'Return seating',
  'global.seating': 'Seating',
  'global.gateway_url': 'Gateway URL',
  'global.summary': 'Summary',
  'global.action': 'Action',
  'global.created_at': 'Created at',
  'global.created_by': 'Created by',
  'global.roundtrip': 'Roundtrip',

  'sites.url': 'URL',
  'sites.ga_script': 'Google analytic script',
  'global.meta_data': 'Meta Data',
  'global.meta_title': 'Meta title',
  'global.meta_description': 'Meta Description',
  'global.meta_keywords': 'Meta Keywords',
  'global.before_head': 'Before Head',
  'global.before_body': 'Before Body',
  'global.layout': 'Layout',
  'global.socials': 'Socials',

  // status
  'global.all': 'All',
  'global.pending': 'Pending',
  'global.confirmed': 'Confirmed',
  'global.cancelled': 'Cancelled',
  'global.refund': 'Refund',
  'global.mark_as_paid': 'Mark as paid',

  'global.super': 'Super',
  'global.admin': 'Admin',
  'global.staff': 'Staff',
  'global.agent': 'Agent',
  'global.upgrade': 'Upgrade',
  'global.cabin_no': 'Cabin No',
  'global.carriage': 'Carriage',
  'global.cabin_type': 'Cabin Type',
  'global.view_seat': 'View Seat',
  'global.view': 'View',
  'global.ok': 'Ok',
  'global.seats': 'Seats',
  'global.time_period': 'Time period',
  'global.booked_seats': 'Booked seats',
  'global.allocated_seat': 'Allocated seat',
  'global.revenue': 'Revenue',
  'global.revenue_report': 'Revenue report',
  'global.cabins_performance': 'Cabins performance',
  'global.created_date': 'Created date',
  'global.depart_date': 'Depart date',
  'global.download': 'Download',
  'global.permission': 'Permission',
  'global.permissions': 'Permissions',
  'permissions.decline': 'Decline',
  'permissions.allow': 'Allow',
  'global.e_ticket': 'E-Ticket',
  'global.internal_notes': 'Internal notes',
  'global.information_customer': 'Information customer',
  'global.cgroup': 'Customer group',
  'global.order_information': 'Booking information',
  'global.accountant_email': 'Accountant email',
  'global.more': 'more',
  'global.full': 'Full',
  'global.deposited': 'Deposited',
  'global.payment_type': 'Payment type',
  'global.payment_status': 'Payment status',
  'global.contact_information': 'Contact information',
  'global.contacts': 'Contacts',
  'global.contact': 'Contact',
  'global.add_contact': 'Add contact',
  'global.office': 'Office',
  'global.select_contact': 'Select contact',
  'global.select_seller': 'Select seller',
  'global.input_group_code': 'Input code',
  'global.input_pax': 'Input pax',
  'global.input_order_notes': 'Input order notes',
  'global.input_order_internal_notes': 'Input order internal notes',
  'global.input_contact_name': 'Input contact name',
  'global.input_contact_email': 'Input contact email',
  'global.input_contact_mobile': 'Input contact mobile',
  'validate.is_not_email': 'Field is not email',
  'validate.is_not_phone_number': 'Field is not phone number',
  'order.select_other_contact': 'Other',
  'global.select_hop': 'Select a hop',
  'global.select_route': 'Select a route',
  'global.book': 'Book',
  'global.user': 'User',
  'global.save_success': 'Save successfully',
  'global.save_failed': 'Save failed',
  'global.guide_number': 'Guide',
  'global.input_guide_number': 'Input guide',
  'global.input_your_password': 'Please input your password!',
  'global.input_beds': "Please input beds's name or delete this field",
  'global.input_email_or_delete':
    "Please input email's name or delete this field",
  'global.select_destination_start': 'Select destination start',
  'global.select_destination_end': 'Select destination end',
  'placeholder.select_hop': 'Select hop',
  'placeholder.select_addon': 'Select add-on',
  'placeholder.from': 'From',
  'placeholder.to': 'To',
  'placeholder.select_category': 'Select category',
  'placeholder.select_customer_group': 'Select customer group',
  'global.select_user': 'Select user',
  'placeholder.select_user': 'Select user',
  'global.select_permission': 'Select permission',
  'global.select_all': 'Select all',
  'global.advanced_settings_for_each_user': 'Advanced settings for each user',
  'note.reload_page': 'Need to reload the page after finishing editing',
  'global.history': 'History',
  'global.clear': 'Clear',
  'history.from_date': 'From date',
  'history.to_date': 'To date',
  'history.week_days': 'Weekdays',
  'global.reload': 'Reload',
  'global.clear_rate_confirm': 'Are you sure want to clear this data?',
  'placeholder.booking_id_or_code': 'Booking ID or Code',
  'global.special_notes': 'Special notes',
  'placeholder.input_special_notes': 'Input special notes',
  'global.choice_a_time_period': 'Choice a time period',
  'global.not_found': 'Not found',
  'global.select_a_customer': 'Select a customer',
  'placeholder.select_customer': 'Select customer',
  'placeholder.input_notes': 'Input notes',
  'placeholder.input_description': 'Input description',
  'placeholder.select_creator': 'Select creator',
  'placeholder.select_status': 'Select status',
  'placeholder.payment_from': 'Payment from',
  'placeholder.payment_to': 'Payment to',
  'global.initialization_time': 'Initialization time',
  'placeholder.input_title': 'Input title',
  'placeholder.input_code': 'Input code',
  'placeholder.select_route': 'Select route',
  'error.quantity_is_not_the_same':
    'Quantity is not the same as ordered quantity',
  'global.addons_booking': 'Additional services',
  'error.missing_addon': 'Please select an add-on',
  'warning.not_found_carriages': 'No carriages available',
  'global.individual': 'Individual',
  'global.available': 'Available',
  'global.booking_statistics': 'Booking statistics',
  'global.total_number_of_tickets': 'Total number of tickets',
  'global.sold': 'Sold',
  'global.remaining': 'Remaining',
  'global.capacity': 'Capacity',
  'global.general_capacity': 'General capacity',
  'global.files_manager': 'Files manager',
  'error.upload_file': 'Error uploading file. Please try again.',
  'success.upload_file': 'File uploaded successfully!',
  'global.create_folder': 'Create folder',
  'placeholder.input_folder_name': 'Input folder name',
  'global.folder_name': 'Folder name',
  'error.create_folder': 'Error create folder. Please try again.',
  'error.delete_file': 'Error delete, please try again.',
  'error.folder_name': 'Invalid folder name, please try again.',
  'error.missing_file_upload': 'Please select a file to upload.',
  'placeholder.select_date': 'Select date',
  'placeholder.input_email': 'Input email',
  'global.send': 'Send',
  'global.download_addon_booking': 'Download additional services',
  'error.send_email': 'Error send email. Please try again.',
  'global.send_email_success': 'Email sent successfully',
  'global.customer_name': 'Customer name',
  'global.seated_by': 'Seated by',
  'global.seated_date': 'Seated date',
  'sidebar.invoice': 'Invoice',
  'global.booked_from': 'Booked from',
  'global.booked_to': 'Booked to',
  'global.amount_of_money': 'Amount of money',
  'global.track': 'Track',
  'placeholder.input_track': 'Input track',
  'global.amenities': 'Amenities',
  'global.icon': 'Icon',
  'error.must_contain_least_one_value':
    'Must contain at least one information of passenger',
  'global.representative_passenger': 'Representative passenger',
  'placeholder.input_firstname': 'Input firstname',
  'placeholder.input_lastname': 'Input lastname',
  'error.missing_passenger_information':
    'Please input least one information of passenger',
  'global.refund_policy': 'Refund Policies',
  'global.refund_policies': 'Refund Policies',
  'global.cancel_fee': 'Cancel fee',
  'global.hours': 'Hours',
  'global.is_default': 'Is Default',
  'global.select_tours': 'Select a tour',
  'global.payments': 'Payments',
  'global.payment_date': 'Payment date',
  'global.payment': 'Payment',
  'global.refund_recording': 'Refund recording',
  'global.transaction': 'Transaction',
  'global.transactions': 'Transactions',
  'global.penalty_date': 'Penalty date',
  'global.today': 'Today',
  'global.penalty_status': 'Penalty status',
  'global.no_payment_yet': 'No payment yet',
  'global.tour': 'Tour',
  'placeholder.input_amount': 'Input amount',
  'success.refund_recorded': 'Refund recorded',
  'global.adults': 'Adults',
  'global.children': 'Children',
  'global.infants': 'Infants',
  'global.pickup_location': 'Pickup location',
  'global.income': 'Income',
  'global.expense': 'Expense',
  'global.pay': 'Pay',
  'global.debit': 'Debit',
  'global.amount': 'Amount',
  'global.transaction_date': 'Transaction date',
  'global.guest_payment_date': 'Transaction date',
  'global.policy_penalty_name': 'Penalty policy name',
  'global.guest_payment': 'Transaction',
  'global.guest_payment_detail': 'Transaction detail',
  'global.waiting_approve': 'Waiting approve',
  'global.created_payments': 'Created payments',
  'tour.pickup_offered': 'Pickup Offered',
  'global.pickup_offer': 'Pickup offer',
  'global.both': 'Both',
  'global.free_cancel': 'Free cancel',
  'global.penalty': 'Penalty',
  'global.cancel_booking': 'Cancel booking',
  'global.pickup_time': 'Pickup time',
  'global.create_transaction': 'Create transaction',
  'global.depart_value': 'Depart value',
  'global.penalty_amount': 'Penalty amount',
  'global.add_pickup': 'Add pickup',
  'global.select_meeting_type': 'Select meeting point type',
  'global.book_tour': 'Book tour: ',
  'global.endWorkingTime': 'End working time',

  //payment method
  'global.merchant_id': 'Merchant Id',
  'global.secret_key': 'Secret Key',
  'global.notify_url': 'Notify URL',
  'global.identifiant': 'Identifiant',
  'global.error_url': 'Error URL',
  'global.success_url': 'Success URL',
  'global.client_id': 'Client Id',
  'global.merchant_account': 'Merchant Account',
  'global.client_secret': 'Client Secret',
  'global.callback_url': 'Callback URL',
  'global.yobuma': 'Yobuma',
  'global.markets': 'Markets',

  //
  'global.send_link_payment': 'Send Link Payment',
  'global.filter_params': 'Filters',
  'global.category_id': 'Category',
  'global.destination_id': 'Destination',

  'global.market': 'Market',
  'global.flat': 'Flat',
  'global.commission_amount': 'Commission amount',

  'global.waiting': 'Waiting',

  'global.select_operators': 'Select Operators',
  'order.supplier_status': 'Supplier Status',
  'global.free_cancel_date': 'Free Cancel Date',
  'global.time_start': 'Time Start',
  'global.supplier_total': 'Supplier Total',
  'global.edit_pickup': 'Edit Pickup',

  'global.drop_off': 'Drop off',
  'global.driver_notes': 'Driver_notes',
  'global.policies': 'Policies',
  'global.cancellation_policy_summary': 'Cancellation',
  'global.service_fee': 'Service fee',
  'global.ordering': 'Ordering',
  'global.price_cron': 'Price cron',
  'global.unit': 'Unit',

  'global.subtotal': 'Subtotal',
  'global.refund_amount': 'Refund amount',
  'global.cancellation_date': 'Cancellation date',
  'global.cancellation_fee': 'Cancellation fee',
  'global.cache_reset': 'Cache reset',
  'global.additional_info': 'Additional info',
  'global.driver': 'Driver',

  'global.select_type': 'Select Type',
  'global.brand': 'Brand',

  // crm
  'global.crm': 'CRM',
  'global.segments': 'Segments',
  'global.templates': 'Templates',
  'global.campaigns': 'Campaigns',
  'global.phone_code': 'Phone code',
  'global.action_date': 'Action date',
  'global.date_of_birth': 'Date of Birth',
  'global.lead_status': 'Lead status',
  'global.new': 'New',
  'global.open': 'Open',
  'global.in_progress': 'In progress',
  'global.unqualified': 'Unqualified',
  'global.attempted_to_contact': 'Attempted to contact',
  'global.connected': 'Connected',
  'global.bad_timing': 'Bad timing',
  'global.subscribed': 'Subscribed',
  'global.unsubscribed': 'Unsubscribed',
  'global.owner': 'Owner',
  'global.subject': 'Subject',
  'global.once': 'Once',
  'global.daily': 'Daily',
  'global.repeat': 'Repeat',
  'global.audiences': 'Audiences',
  'global.analytics': 'Analytics',
  'global.opened': 'Opened',
  'global.schedule_date': 'Schedule date',
  'global.send_now': 'Send now',
  'global.campaign_key': 'Campaign key',
  'global.segment': 'Segment',
  'global.template': 'Template',
  'global.links': 'Links',
  'global.conditions': 'Conditions',
  'global.is': 'Is',
  'global.is_not': 'Is not',
  'global.contain': 'Contain',
  'global.not_contain': 'Not contain',
  'global.start_with': 'Start with',
  'global.end_with': 'End with',
  'global.send_index': 'Send IndexNow',
  'global.send_success': 'Message sent',
  'global.send_failed': 'Message not sent',
  'global.source': 'Source',
  'global.apply': 'Apply',
  'global.sent': 'Sent',
  'global.not_send': 'Not sent',
  'global.sent_date': 'Sent date',
  'global.recipients': 'Recipients',
  'global.campaign_status': 'Campaign status',
  'global.running': 'Running',
  'global.stopped': 'Stopped',
  'global.create_segment': 'Create segment',
  'global.clicked': 'Clicked',
  'global.start': 'Start',
  'global.stop': 'Stop',
  'global.completed': 'Completed',
  'global.not_open': 'Not open',
  'global.not_click': 'Not click',
  'global.promotions': 'Promotions',
  'global.promotion': 'Promotion',
  'global.used_from': 'Used from',
  'global.used_to': 'Used to',
  'global.used_at': 'Used at',
  'global.discounts': 'Discounts',
  'placeholder.select_group': 'Select Group',
  'global.customer_group': 'Customer Group',
  'global.booked_at_from': 'Booked from',
  'global.booked_at_to': 'Booked to',
  'placeholder.booked_at_from': 'Booked from',
  'placeholder.booked_at_to': 'Booked to',
  'placeholder.used_at_from': 'Used from',
  'placeholder.used_at_to': 'Used to',
  'global.booked_at': 'Booked at',

  // ROUTE CONFIGURATION
  'global.route_config': 'Route config',
  'global.seat_map': 'Seat map',
  'global.row': 'Row',
  'global.column': 'Column',
  'global.vehicles': 'Vehicles',
  'global.short_name': 'Short name',
  'global.user_id': 'User ID',
  'placeholder.select_operator': 'Select operator',
  'global.serial': 'Serial',
  'placeholder.select_seat_map': 'Select seat map',
  'global.preview_seat_map': 'Preview seat map',
  'global.start_location': 'Start location',
  'global.end_location': 'End location',
  'global.end_time': 'End time',
  'global.vehicle': 'Vehicle',
  'placeholder.select_vehicle': 'Select vehicle',
  'placeholder.select_start_location': 'Select start location',
  'placeholder.select_end_location': 'Select end location',
  'global.destination_map': 'Destination map',
  'global.segment_title': 'Segment title',
  'global.add_segment': 'Add segment',
  'global.payment-method': 'Payment method',
  'global.order_no': 'Order No',
  'global.rates': 'Rates',
  'global.agency_staff': 'Agency staff',
  'global.add_agency_staff': 'Add agency staff',
  'global.create_return_route': 'Create Return Route',
  'global.settings': 'Settings',
  'global.label': 'Label:',
  'global.value': 'Value',
  'global.create_price_ddd': 'Create Price DDD',
  'global.recentActivity': 'Recent Activity',
  'global.username': 'username',
  'global.tax': 'Tax',
  'global.day': 'Day',
  'global.booking_statistic': 'Report de voyage',
  'global.trajet_id': 'trajet id',
  'global.group_route': 'Group By Route',
  'global.default': 'Default System',
  'global.sms_payment': 'Sms Payment',
  'global.ticket_settings': 'Ticket Settings',
  'global.code_type': 'Code Type',
  'global.qr_code': 'QR Code',
  'global.bar_code': 'Bar Code',
  'global.filling_rate': 'Filling rate',
  'global.trips': 'Trips',

  'global.sale_currency_decimald': 'Décimal devise',
  'global.sale_currency_display': 'Affichage devise',
  'global.sale_currency_main': 'Devise principale',
  'global.sale_date': 'Date de vente',
  'global.sale_date_type': 'Type de date de vente',
  'global.sale_date_upto': 'Date limite de vente',
  'global.sale_edit_days': 'Jours d’édition',
  'global.sale_edit_enable': 'Activer modification',
  'global.sale_edit_times': 'Nombre de modifications',
  'global.sale_edit_type': 'Type de modification',
  'global.sale_fee': 'Frais (%)',
  'global.sale_is_fee_default': 'Frais par défaut',
  'global.sale_status': 'Statut',
};

export default lang;
